module.exports = __webpack_public_path__ + "static/media/mobile-icon-otp.209b3ba8.svg";